import React from "react";
import PropTypes from "prop-types";
import {
  ImprovedDropDown as DropDown,
  ImprovedDropDownItem
} from "MODULES/shared/components/DropDown";
import _ from "lodash";
import { DownloadCocModal } from "MODULES/PurchaseOrders/components/Detail/DownloadCocModal/DownloadCocModal";

function LineItemControls({ lineItem, purchaseOrderId }) {
  return (
    <div>
      <DropDown>
        <ImprovedDropDownItem
          id="download-coc"
          label="Download CoC"
          faIcon="download"
          renderActive={
            <DownloadCocModal
              lineItem={lineItem}
              purchaseOrderId={purchaseOrderId}
            />
          }
        />
      </DropDown>
    </div>
  );
}

LineItemControls.propTypes = {
  lineItem: PropTypes.shape({}).isRequired
};

export default LineItemControls;



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/CoreReceivedTable/LineItemControls.jsx